import { Component, OnInit, Input } from '@angular/core';
import { ScreenSizeService } from 'src/app/services/screen-size.service';
import { UtilityService } from 'src/app/services/utility.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';

@Component({
  selector: 'app-auth-header',
  templateUrl: './auth-header.component.html',
  styleUrls: ['./auth-header.component.css'],
})
export class AuthHeaderComponent implements OnInit {
  @Input() title: string = 'P2P Energy Trading Registration';
  isMobile: boolean = false;
  utilityLogo: string = '';

  constructor(
    private screenSizeService: ScreenSizeService,
    private localStorageService: LocalStorageService,
    private utilityService: UtilityService
  ) {}

  ngOnInit(): void {
    this.screenSizeService.isMobile$.subscribe(isMobile => {
      this.isMobile = isMobile;
    });
    this.loadUtilityLogo();
  }

  loadUtilityLogo(): void {
    const utilityId = this.localStorageService.getUtilityId();
    this.utilityService.loadLogoDataUrl(utilityId).subscribe(logo => {
      this.utilityLogo = logo;
    });
  }
}
